import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Proband, Run } from '../../../data/data';

@Component({
    selector: 'page-recordsproband',
    templateUrl: 'recordsProband.html'
})
export class RecordsProbandPage {

    public proband: Proband;
    public selectedRun: Run;

    constructor(
        public navCtrl: NavController,
        private navParams: NavParams
    ) {
        this.proband = this.navParams.get('proband');
    }

    public show(run: Run): void {
        if (this.selectedRun == run) {
            this.selectedRun = null;
        } else {
            this.selectedRun = run;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/records/recordsSession/recordsProband.ts